import {Component, OnInit} from '@angular/core';
import {UtilitiesService} from '../../helpers/utilities.service';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
    private URL: string = "";
    companies: string = this.URL + '/history/companies.webp';

    images = [];

    constructor(private utils: UtilitiesService) {
        this.URL = this.utils.getStaticImageApi();
        this.images = [
            {path: this.URL + '/history/best_history1.webp'},
            {path: this.URL + '/history/best_history2.webp'},
            {path: this.URL + '/history/best_history3.webp'},
            {path: this.URL + '/history/best_history4.webp'},
            {path: this.URL + '/history/best_history5.webp'},
        ];
    }

    ngOnInit(): void {
    }
}
